import type { ProctoringAwayReason } from "@/src/helpers/proctoring-away-reason";

export type ParticipantTabChangedWebhookPayload = {
  event: "participant_tab_changed";
  room: {
    name: string;
    sid?: string;
    type: string;
    meet_id?: number;
  };
  participant: {
    identity: string;
    name?: string;
    metadata?: unknown;
    attributes?: Record<string, string>;
  };
  proctoring: {
    /**
     * Время, когда кандидат ушел из вкладки в миллисекундах
     */
    leftTabAtTimestamp: number;
    /**
     * Время, когда кандидат вернулся во вкладку в миллисекундах
     */
    returnedAtTimestamp: number;
    /**
     * Время, проведенное участником в другой вкладке в миллисекундах
     */
    wasAwayFromTabFor: number;
    /**
     * Чем именно браузер объяснил уход: страница скрылась или окно потеряло фокус.
     */
    reason: ProctoringAwayReason;
  };
};

export const sendParticipantTabChangedWebhook = async (
  payload: ParticipantTabChangedWebhookPayload,
) => {
  try {
    const response = await fetch("/api/proctoring_webhook", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(`HURMA webhook request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("Error sending participant tab changed webhook:", error);
  }
};
